import React, { useEffect, useState } from 'react';
import { Container,IconButton } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';

import { DataGrid } from '@material-ui/data-grid';
import ImageGallery from 'react-image-gallery';

import TableHeader from '../common/TableHeader';
import { ImagePreview } from './style';
import { ModalAction } from '../common/Modal';

import { getContracts } from '../../actions/Contracts';
import { Text } from '../common/NotificationTable/style';
import { Noresults } from '../../Layout/style';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';

const Contracts = () => {
  const dispatch = useDispatch();
  const { contracts } = useSelector(({ contracts }) => ({
    contracts: contracts?.contracts || [],
  }));

  const [modalOpen, setModalOpen] = useState({
    open: false,
    url: null,
  });
  const [searchString, setSearchString] = useState('');
  const [filteredElements, setFilteredElements] = useState('');
  const [images, setImages] = useState([]);

  useEffect(() => {
    dispatch(getContracts());
  }, []);

  useEffect(() => {
    const cleanValue = searchString.replace(/[-[/\]{}()*+?.,\\^$|#]/g, '');
    const searchRegex = new RegExp(`${cleanValue}`, 'gi');
    const searchedItens = contracts.filter((i) => i.name.match(searchRegex));

    if (!searchRegex) setFilteredElements(contracts);
    else setFilteredElements(searchedItens);
  }, [contracts, searchString]);

  const handleOpen = (row) => {
    setModalOpen({ open: true, images: row ? true : false });
    if (row) {
      let imagens = []
      if(row?.firstImage?.Location){
        imagens.push({
          title:row?.name,
          original: row?.firstImage?.Location,
          thumbnail: row?.firstImage?.Location,
        })
      }
      if(row?.secondImage?.Location){
        imagens.push({
          original: row?.secondImage?.Location,
          thumbnail: row?.secondImage?.Location,
        })
      }
      if(row?.thirdImage?.Location){
        imagens.push({
          original: row?.thirdImage?.Location,
          thumbnail: row?.thirdImage?.Location,
        })
      }
      setImages(imagens);
    }
  };

  const handleClose = () => {
    setModalOpen({ open: false, images: false });
    setImages([]);
  };

  const columns = [
    {
      field: 'name',
      width: 200,
      headerName: 'Cliente',
      sortable: true,
      renderCell: ({ row }) => <Text>{row.name}</Text>,
    },
    {
      field: 'files',
      width: 250,
      renderCell: ({ row }) => (
        <>
          {row.firstImage?.Location && <ImagePreview onClick={() => handleOpen(row)} src={row.firstImage?.Location} />}
          {/* {row.secondImage?.Location && <ImagePreview onClick={() => handleOpen(row)} src={row.secondImage?.Location} />}
          {row.thirdImage?.Location && <ImagePreview onClick={() => handleOpen(row)} src={row.thirdImage?.Location} />} */}
        </>
      ),
      headerName: 'Visualizar',
    },
    {
      field: 'startDate',
      width: 150,
      headerName: 'Início',
      renderCell: ({ row }) => <Text>{row.startDate}</Text>,
    },
    {
      field: 'business',
      width: 150,
      headerName: 'Negócio',
      renderCell: ({ row }) => <Text>{row.business}</Text>,
    },
    {
      align:'center',
      field: 'locale',
      width: 180,
      headerName: 'Localização',
       renderCell: ({ row }) => (
        <>
          <IconButton onClick={() => window.open(row.locale, '_blank').focus()}>
            <FontAwesomeIcon icon={faMapMarkerAlt} />
          </IconButton>
        </>
      ),
    },
  ];
  
  return (
    <>
      <Container>
        <TableHeader setSearchString={setSearchString} placeholder="Pesquisar por Nome" />
        <div style={{ height: 500, width: '100%', background: 'white', overflowX: 'auto' }}>
          <DataGrid
           components={{
            NoRowsOverlay: () => (
              <Noresults>
                <span>
                  Resultados não encontrado
                </span>
              </Noresults>
            ),
          }}
            pageSize={10}
            disableSelectionOnClick
            disableColumnMenu
            hideFooterSelectedRowCount
            rows={filteredElements.length ? filteredElements : []}
            rowHeight={100}
            columns={columns}
          />
        </div>
        <ModalAction title={'Novos Contratos - '+ images?.[0]?.title || ''} open={modalOpen?.open} backAction={() => handleClose()}>
          <ImageGallery items={images}  />
        </ModalAction>
      </Container>
    </>
  );
};

export default Contracts;
